"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgDescriptionEditCtl = /** @class */ (function (_super) {
    __extends(DlgDescriptionEditCtl, _super);
    function DlgDescriptionEditCtl() {
        return _super.call(this, true) || this;
    }
    DlgDescriptionEditCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            description: "",
            title: "",
            visible: false
        };
    };
    DlgDescriptionEditCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgDescriptionEditCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgDescriptionEditCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgDescriptionEditCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgDescriptionEditCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgDescriptionEditCtl.prototype, "onYesClick", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgDescriptionEditCtl.prototype.SetTitle = function (title) {
        this.DATA.title = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgDescriptionEditCtl.prototype, "Title", {
        get: function () {
            return this.DATA.title;
        },
        enumerable: true,
        configurable: true
    });
    DlgDescriptionEditCtl.prototype.SetDescription = function (description) {
        this.DATA.description = description;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgDescriptionEditCtl.prototype, "Description", {
        get: function () {
            return this.DATA.description;
        },
        enumerable: true,
        configurable: true
    });
    return DlgDescriptionEditCtl;
}(BaseController_1.BaseController));
exports.DlgDescriptionEditCtl = DlgDescriptionEditCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgDescriptionEditCtl.ts
// module id = 896
// module chunks = 0